import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

const PUBLIC_ROUTES = ["/", "/login_payment_exec", "/forgot", "/reset-password", "/password-success"];

const PrivateRoute = () => {
  const location = useLocation();
  const isAuthenticated = useSelector((state) => state?.admin?.isAuthenticated);
  const rehydrated = useSelector((state) => state?._persist?.rehydrated);

  // DEBUG - tell me what these print
  console.log("📍 Current path:", location.pathname);
  console.log("✅ isAuthenticated:", isAuthenticated);
  console.log("💾 rehydrated:", rehydrated);
  console.log("🔓 is public route:", PUBLIC_ROUTES.includes(location.pathname));

  if (!rehydrated) return null;

  if (PUBLIC_ROUTES.includes(location.pathname)) {
    return <Outlet />;
  }

  return isAuthenticated ? <Outlet /> : <Navigate to="/" replace />;
};

export default PrivateRoute;